import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import cnaeGroupReadAction from './cnaeGroupRead.action.json' assert { type: 'json' }

const cnaeGroupReadDefinition = defineReadAutoAction(cnaeGroupReadAction, 'cnaeGroup')

export default cnaeGroupReadDefinition
